import Cookies from "js-cookie";
// cookie保存的天数
import config from "@/config";
import { forEach, hasOneOf, objEqual } from "@/libs/tools";
import { getDate, dateFormat, computeDateByDay } from "@/libs/timeUtil";
import { add, reduce, mul, div } from "@/util/NumberUtil";

const { cookieExpires, useI18n } = config;

// 配置文件抽离可动态修改 2019-10-24 gsz
// import store from '../store/index';

// let title = "title";
// console.log(title);

export const TOKEN_KEY = "yljxsorting-token";

export const setToken = token => {
	Cookies.set(TOKEN_KEY, token, { expires: cookieExpires || 1 });
};

export const getToken = () => {
	const token = Cookies.get(TOKEN_KEY);
	if (token) {
		return token;
	} else {
		return false;
	}
};

export const hasChild = item => {
	return item.children && item.children.length !== 0;
};

const showThisMenuEle = (item, access) => {
	if (item.meta && item.meta.access && item.meta.access.length) {
		if (hasOneOf(item.meta.access, access)) {
			return true;
		} else {
			return false;
		}
	} else {
		return true;
	}
};
/**
 * @param {Array} list 通过路由列表得到菜单列表
 * @returns {Array}
 */
export const getMenuByRouter = (list, access) => {
	// console.log(list)
	let res = [];
	forEach(list, item => {
		if (!item.meta || (item.meta && !item.meta.hideInMenu)) {
			let obj = {
				icon: (item.meta && item.meta.icon) || "",
				name: item.name,
				title: item.title,
				meta: item.meta
			};
			if (
				(hasChild(item) || (item.meta && item.meta.showAlways)) &&
				showThisMenuEle(item, access)
			) {
				obj.children = getMenuByRouter(item.children, access);
			}
			if (item.meta && item.meta.href) obj.href = item.meta.href;
			if (showThisMenuEle(item, access)) res.push(obj);
		}
	});
	// console.log(res)
	return res;
};

/**
 * @param {Array} routeMetched 当前路由metched
 * @returns {Array}
 */
export const getBreadCrumbList = (route, homeRoute) => {
	let homeItem = { ...homeRoute, icon: homeRoute.meta.icon };
	let routeMetched = route.matched;
	if (routeMetched.some(item => item.name === homeRoute.name))
		return [homeItem];
	let res = routeMetched
		.filter(item => {
			return item.meta === undefined || !item.meta.hideInBread;
		})
		.map(item => {
			let meta = { ...item.meta };
			if (meta.title && typeof meta.title === "function") {
				meta.__titleIsFunction__ = true;
				meta.title = meta.title(route);
			}
			let obj = {
				icon: (item.meta && item.meta.icon) || "",
				name: item.name,
				title: item.title,
				meta: meta
			};
			return obj;
		});
	res = res.filter(item => {
		return !item.meta.hideInMenu;
	});
	return [{ ...homeItem, to: homeRoute.path }, ...res];
};

export const getRouteTitleHandled = route => {
	let router = { ...route };
	let meta = { ...route.meta };
	let title = "";
	if (meta.title) {
		if (typeof meta.title === "function") {
			meta.__titleIsFunction__ = true;
			title = meta.title(router);
		} else {
			title = meta.title;
		}
	}
	meta.title = title;
	router.meta = meta;
	return router;
};

export const showTitle = (item, vm) => {
	let { title, __titleIsFunction__ } = item.meta;
	if (!title) return;
	if (useI18n) {
		if (title.includes("{{") && title.includes("}}") && useI18n) {
			title = title.replace(/({{[\s\S]+?}})/, (m, str) =>
				str.replace(/{{([\s\S]*)}}/, (m, _) => vm.$t(_.trim()))
			);
		} else if (__titleIsFunction__) {
			title = item.meta.title;
		} else {
			title = vm.$t(item.name);
		}
	} else {
		title = (item.meta && item.meta.title) || item.name;
	}
	return title;
};

/**
 * @description 本地存储和获取标签导航列表
 */
export const setTagNavListInLocalstorage = list => {
	localStorage.tagNaveList = JSON.stringify(list);
};
/**
 * @returns {Array} 其中的每个元素只包含路由原信息中的name, path, meta三项
 */
export const getTagNavListFromLocalstorage = () => {
	const list = localStorage.tagNaveList;
	return list ? JSON.parse(list) : [];
};

/**
 * @param {Array} routers 路由列表数组
 * @description 用于找到路由列表中name为home的对象
 */
export const getHomeRoute = (routers, homeName = "home") => {
	let i = -1;
	let len = routers.length;
	let homeRoute = {};
	while (++i < len) {
		let item = routers[i];
		if (item.children && item.children.length) {
			let res = getHomeRoute(item.children, homeName);
			if (res.name) return res;
		} else {
			if (item.name === homeName) homeRoute = item;
		}
	}
	return homeRoute;
};

/**
 * @param {*} list 现有标签导航列表
 * @param {*} newRoute 新添加的路由原信息对象
 * @description 如果该newRoute已经存在则不再添加
 */
export const getNewTagList = (list, newRoute) => {
	const { name, path, meta } = newRoute;
	let newList = [...list];
	if (newList.findIndex(item => item.name === name) >= 0) {
		return newList;
	} else {
		newList.push({ name, path, meta });
	}
	return newList;
};

/**
 * @param {*} access 用户权限数组，如 ['super_admin', 'admin']
 * @param {*} route 路由列表
 */
const hasAccess = (access, route) => {
	if (route.meta && route.meta.access) {
		return hasOneOf(access, route.meta.access);
	} else {
		return true;
	}
};

/**
 * 权鉴
 * @param {*} name 即将跳转的路由name
 * @param {*} access 用户权限数组
 * @param {*} routes 路由列表
 * @description 用户是否可跳转到该页
 */
export const canTurnTo = (name, access, routes) => {
	const routePermissionJudge = list => {
		return list.some(item => {
			if (item.children && item.children.length) {
				return routePermissionJudge(item.children);
			} else if (item.name === name) {
				return hasAccess(access, item);
			}
		});
	};

	return routePermissionJudge(routes);
};

/**
 * @param {String} url
 * @description 从URL中解析参数
 */
export const getParams = url => {
	const keyValueArr = url.split("?")[1].split("&");
	let paramObj = {};
	keyValueArr.forEach(item => {
		const keyValue = item.split("=");
		paramObj[keyValue[0]] = keyValue[1];
	});
	return paramObj;
};

/**
 * @param {Array} list 标签列表
 * @param {String} name 当前关闭的标签的name
 */
export const getNextRoute = (list, route) => {
	let res = {};
	if (list.length === 2) {
		res = getHomeRoute(list);
	} else {
		const index = list.findIndex(item => routeEqual(item, route));
		if (index === list.length - 1) {
			res = list[list.length - 2];
		} else {
			res = list[index + 1];
		}
	}
	return res;
};

/**
 * @param {Number} times 回调函数需要执行的次数
 * @param {Function} callback 回调函数
 */
export const doCustomTimes = (times, callback) => {
	let i = -1;
	while (++i < times) {
		callback(i);
	}
};

/**
 * @param {Object} file 从上传组件得到的文件对象
 * @returns {Promise} resolve参数是解析后的二维数组
 * @description 从Csv文件中解析出表格，解析成二维数组
 */
export const getArrayFromFile = file => {
	let nameSplit = file.name.split(".");
	let format = nameSplit[nameSplit.length - 1];
	return new Promise((resolve, reject) => {
		let reader = new FileReader();
		reader.readAsText(file); // 以文本格式读取
		let arr = [];
		reader.onload = function (evt) {
			let data = evt.target.result; // 读到的数据
			let pasteData = data.trim();
			arr = pasteData
				.split(/[\n\u0085\u2028\u2029]|\r\n?/g)
				.map(row => {
					return row.split("\t");
				})
				.map(item => {
					return item[0].split(",");
				});
			if (format === "csv") {
				resolve(arr);
			} else {
				reject(new Error("[Format Error]:你上传的不是Csv文件"));
			}
		};
	});
};

/**
 * @param {Array} array 表格数据二维数组
 * @returns {Object} { columns, tableData }
 * @description 从二维数组中获取表头和表格数据，将第一行作为表头，用于在iView的表格中展示数据
 */
export const getTableDataFromArray = array => {
	let columns = [];
	let tableData = [];
	if (array.length > 1) {
		let titles = array.shift();
		columns = titles.map(item => {
			return {
				title: item,
				key: item
			};
		});
		tableData = array.map(item => {
			let res = {};
			item.forEach((col, i) => {
				res[titles[i]] = col;
			});
			return res;
		});
	}
	return {
		columns,
		tableData
	};
};

export const findNodeUpper = (ele, tag) => {
	if (ele.parentNode) {
		if (ele.parentNode.tagName === tag.toUpperCase()) {
			return ele.parentNode;
		} else {
			return findNodeUpper(ele.parentNode, tag);
		}
	}
};

export const findNodeUpperByClasses = (ele, classes) => {
	let parentNode = ele.parentNode;
	if (parentNode) {
		let classList = parentNode.classList;
		if (
			classList &&
			classes.every(className => classList.contains(className))
		) {
			return parentNode;
		} else {
			return findNodeUpperByClasses(parentNode, classes);
		}
	}
};

export const findNodeDownward = (ele, tag) => {
	const tagName = tag.toUpperCase();
	if (ele.childNodes.length) {
		let i = -1;
		let len = ele.childNodes.length;
		while (++i < len) {
			let child = ele.childNodes[i];
			if (child.tagName === tagName) {
				return child;
			} else {
				return findNodeDownward(child, tag);
			}
		}
	}
};

export const showByAccess = (access, canViewAccess) => {
	return hasOneOf(canViewAccess, access);
};

/**
 * @description 根据name/params/query判断两个路由对象是否相等
 * @param {*} route1 路由对象
 * @param {*} route2 路由对象
 */
export const routeEqual = (route1, route2) => {
	const params1 = route1.params || {};
	const params2 = route2.params || {};
	const query1 = route1.query || {};
	const query2 = route2.query || {};
	let arr = ['service-auditinfo', 'service-add'];
	if ((arr.includes(route1.name) && arr.includes(route2.name))) {
		return true;
	} else {
		return (route1.name === route2.name) && objEqual(params1, params2) && objEqual(query1, query2);
	}

};

/**
 * 判断打开的标签列表里是否已存在这个新添加的路由对象
 */
export const routeHasExist = (tagNavList, routeItem) => {
	let len = tagNavList.length;
	let res = false;
	doCustomTimes(len, index => {
		if (routeEqual(tagNavList[index], routeItem)) res = true;
	});
	return res;
};

export const localSave = (key, value) => {
	localStorage.setItem(key, value);
};

export const localRead = key => {
	return localStorage.getItem(key) || "";
};

// scrollTop animation
export const scrollTop = (el, from = 0, to, duration = 500, endCallback) => {
	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame =
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			window.msRequestAnimationFrame ||
			function (callback) {
				return window.setTimeout(callback, 1000 / 60);
			};
	}
	const difference = Math.abs(from - to);
	const step = Math.ceil((difference / duration) * 50);

	const scroll = (start, end, step) => {
		if (start === end) {
			endCallback && endCallback();
			return;
		}

		let d = start + step > end ? end : start + step;
		if (start > end) {
			d = start - step < end ? end : start - step;
		}

		if (el === window) {
			window.scrollTo(d, d);
		} else {
			el.scrollTop = d;
		}
		window.requestAnimationFrame(() => scroll(d, end, step));
	};
	scroll(from, to, step);
};

/**
 * @description 根据当前跳转的路由设置显示在浏览器标签的title
 * @param {Object} routeItem 路由对象
 * @param {Object} vm Vue实例
 */
export const setTitle = (routeItem, vm) => {
	// console.log(routeItem)
	const handledRoute = getRouteTitleHandled(routeItem);
	const pageTitle = showTitle(handledRoute, vm);
	// let title = store.state.title;
	const resTitle = `${pageTitle}`;
	window.document.title = resTitle;
};

/**
 * @description 将后端菜单树转换为路由树
 * @param {Array} menus
 * @returns {Array}
 */
export const backendMenusToRouters = menus => {
	let routers = [];
	forEach(menus, menu => {
		// 将后端数据转换成路由数据
		let route = backendMenuToRoute(menu);
		// 如果后端数据有下级，则递归处理下级
		if (menu.children && menu.children.length !== 0) {
			route.children = backendMenusToRouters(menu.children);
		}
		routers.push(route);
	});
	return routers;
};

/**
 * @description 剪切字符串
 * @param {String} text 字符串
 * @param {Number} cutNumber 字節數
 */
export const cutTitle = (text, cutNumber) => {

	//一行最多字数
	let textArr = [];
	let reg = /^[\u4e00-\u9fa5]{0,}$/;

	let addNumber = 0;
	let resultNumber = 0;
	for (let indexOffset = 0; indexOffset < text.length && addNumber < cutNumber; indexOffset++) {
		if (reg.test(text[indexOffset])) {
			addNumber += 2;
		} else {
			addNumber += 1;
		}
		resultNumber++;
	}
	return text.substr(0, resultNumber);
};

/**
 * @description 将后端菜单转换为路由
 * @param {Object} menu
 * @returns {Object}
 */
const backendMenuToRoute = menu => {
	// 具体内容根据自己的数据结构来定，这里需要注意的一点是
	// 原先routers写法是component: () => import('@/view/error-page/404.vue')
	// 经过json数据转换，这里会丢失，所以需要按照上面提过的做转换，下面只写了核心点，其他自行处理
	let route = Object.assign({}, menu);
	if (typeof menu.component === "string") {
		route.component = () => import(`@/${menu.component}`);
	}
	return route;
};

// 单位数据转换为想要的单位
export const changeUnit = (value, unit, forUnit) => {
	if (!forUnit) {
		forUnit = 'g';
	}
	let number = 0;
	if (unit == 'g' || unit == 'G' || unit == '克') {
		number = Number(value);
	} else if (unit == 'lb') {
		number = Number((Number(value) * 453.5923).toFixed(3));
	} else if (unit == 'kg' || unit == 'KG' || unit == 'Kg' || unit == '千克' || unit == '公斤') {
		number = Number((Number(value) * 1000).toFixed(3));
	} else if (unit == '斤') {
		number = Number((Number(value) * 500).toFixed(3));
	}
	if (unit == forUnit)
		return value;

	if (forUnit == 'g' || forUnit == 'G' || forUnit == '克') {
		return number;
	} else if (forUnit == 'kg' || forUnit == 'KG' || forUnit == 'Kg' || forUnit == '千克' || forUnit == '公斤') {
		return Number((number / 1000).toFixed(3));
	} else if (forUnit == 'lb') {
		return Number((number / 453.5923).toFixed(3));
	} else if (forUnit == "斤") {
		return Number((number / 500).toFixed(3));
	}
	return value;
};

/**
 * 获取销售单位和基本单位转换
 * @param base_unit 基本单位
 * @param unit 销售单位
 * @param weightG 重量g
 * @param num 销售单位下单数量
 * @param unit_conversion 转换系数
 * @param is_weight 是否计重
 * @param customerBaseUnit 不使用斤的 基本单位
 */
export const getUnitAndBaseUnit = ({ base_unit, weightG, unit, num, unit_conversion, is_weight }) => {
	let result = { unit: "", base_unit: "" };
	if (is_weight == 1) {
		// if (!["斤", "公斤", "克"].includes(base_unit)) base_unit = "斤";
		// if (customerBaseUnit) {
		// 	base_unit = customerBaseUnit;
		// } else {
		// 	base_unit = "斤";
		// }
		let baseUnitWeight = this.changeUnit(weightG, "g", base_unit);
		result.unit = num + unit;
		result.base_unit = baseUnitWeight + base_unit;
		if (unit_conversion == 1) {
			result.showUnit = result.base_unit;
		} else if (unit == base_unit) {
			result.showUnit = result.unit;
		} else {
			result.showUnit = result.unit + "|" + result.base_unit;
		}
	}

	if (is_weight == 2) {
		unit = unit || "份";
		base_unit = base_unit || "份";
		result.unit = num + unit;
		result.base_unit = parseFloat(mul(num, unit_conversion).toFixed(2)) + base_unit;
		if (unit == base_unit || unit_conversion == 1) {
			result.showUnit = result.unit;
		} else {
			result.showUnit = result.unit + "|" + result.base_unit;
		}
	}
	return result;
};

/**
 * 获取已分拣数据销售单位和基本单位转换
 * @param base_unit 基本单位
 * @param unit 销售单位
 * @param weightG 重量g
 * @param unit_conversion 转换系数
 * @param is_weight 是否计重
 * @param customerBaseUnit 不使用斤的 基本单位
 */
export const getHasSortingUnitAndBaseUnit = ({ base_unit, weightG, unit, unit_conversion, is_weight }) => {
	unit_conversion = unit_conversion || 1;
	let result = { unit: "", base_unit: "", unit_conversion };
	if (is_weight == 1) {
		// if (!["斤", "公斤", "克", "kg", "g"].includes(base_unit)) base_unit = "斤";
		let baseUnitWeight = this.changeUnit(weightG, "g", base_unit);
		result.base_unit = baseUnitWeight + base_unit;
		result.base_unit_tag = base_unit;

		result.unit = parseFloat(div(baseUnitWeight, unit_conversion).toFixed(2)) + unit;
		result.unit_tag = unit;

		if (unit_conversion == 1) {
			result.showUnit = result.base_unit;
		} else if (unit == base_unit) {
			result.showUnit = result.unit;
			// console.log('222unit==base_unit', result)
		} else {
			result.showUnit = result.unit + "|" + result.base_unit;
		}
	}

	if (is_weight == 2) {
		unit = unit || "份";
		base_unit = base_unit || "份";
		result.unit_tag = unit || "份";
		result.base_unit_tag = base_unit || "份";
		result.unit = weightG + unit;
		result.base_unit = parseFloat(mul(weightG, unit_conversion).toFixed(2)) + base_unit;
		if (unit == base_unit || unit_conversion == 1) {
			result.showUnit = result.unit;
		} else {
			result.showUnit = result.unit + "|" + result.base_unit;
		}
	}
	return result;
};

// 电子秤数据
let weightData = "";

/**
 * 获取称重数据
 * @param {String} initWeight 原始称重数据
 * @param {type}  weightAgreement 电子秤协议 1通用协议：兴芝电子秤 2顶尖协议：一体机电子秤 3大华协议：外接串口电子秤
 */
export const getWeightData = (initWeight, weightAgreement) => {
	// console.log("原始称重数据", initWeight);
	switch (weightAgreement) { // 电子秤协议
		case "1": // 通用协议：兴芝电子秤
			if (initWeight.charAt(initWeight.length - 1) === '\n') {
				weightData += initWeight.substring(0, initWeight.length - 1);
				if (!weightData.includes("+")) {
					weightData = "";
					return
				}
				if (weightData.includes("+   ") && weightData.replace("+   ", "").charAt(0) === ".") {
					weightData = "";
					return
				}
				weightData = weightData.split("\n")[0];
				formatWeightData(weightData);
				weightData = "";
			} else {
				weightData += initWeight;
			}
			break;
		case "2": // 顶尖协议：一体机电子秤
			// 返回字符串最后一个字符的Unicode编码
			let endStr = initWeight.charAt(initWeight.length - 1).charCodeAt();
			// console.log("endStr", endStr)
			// 一体机电子秤
			if (endStr == 0 || endStr == 16) { // 空字符
				weightData += initWeight;
				if (weightData.length > 12) {
					weightData = weightData.substring(4, 12);
					// console.log("称重数据", weightData);
					formatWeightData(weightData);
					weightData = "";
				} else {
					weightData = "";
				}
			} else {
				weightData += initWeight;
			}
			break;
		case "3": // 大华协议：外接串口电子秤
			if (weightData.length == 22 && weightData.indexOf("\n\r")) { // 换行符
				let newData = weightData.split("   ");
				// console.log("newData", newData);
				weightData = newData[0] + "g";
				formatWeightData(weightData);
				weightData = "";
				weightData += initWeight;
			} else if (weightData.length > 22) { // 字符串长度22为一组(重量、单价、金额)，超过重新初始化
				weightData = "";
			} else {
				weightData += initWeight;
			}
			break;
	}
}

// 格式化称重数据
export const formatWeightData = (weightData) => {
	if (weightData == "+")
		return;
	weightData.replace(/\s+/g, '');
	let realWeight = analysisWeightFromString(weightData);

	let weight = realWeight;
	if (weight < 0) {
		weight = 0;
	}
	// weight = changeUnit(weight, "g", "斤");
	// console.log("重量", weight);
	let event = new CustomEvent("weightCall", {
		detail: {
			weight: weight
		}
	});
	window.dispatchEvent(event);
}

//重量字符串转换为数字重量,单位为g
export const analysisWeightFromString = (weightStr) => {
	// console.log("录入原始数据", weightStr);
	if (typeof (weightStr) == 'string') {
		weightStr = weightStr.replace("sj", "");
		if (weightStr.indexOf("kg") > -1) {
			let obtainSignWeightStr = weightStr.split("kg")[0];
			if (obtainSignWeightStr.indexOf("+") > -1) {
				//正数
				let realNumber = Number(obtainSignWeightStr.split("+")[1]);
				if (realNumber > 0) {
					return realNumber * 1000;
				}
			} else {
				//正数
				let realNumber = Number(obtainSignWeightStr);
				if (realNumber > 0) {
					return realNumber * 1000;
				}
			}
			return 0;
		} else if (weightStr.indexOf("lb") > -1) {
			let obtainSignWeightStr = weightStr.split("lb")[0];
			if (obtainSignWeightStr.indexOf("+") > -1) {
				//正数
				let realNumber = Number(obtainSignWeightStr.split("+")[1]);
				if (realNumber > 0) {
					return Number((realNumber * 453.59).toFixed(3));
				}
			} else {

			}
			return 0;
		} else if (weightStr.indexOf("jg") > -1) {
			let obtainSignWeightStr = weightStr.split("jg")[0];
			// console.log("obtainSignWeightStr", obtainSignWeightStr);
			//正数
			let realNumber = Number(obtainSignWeightStr);
			if (realNumber > 0) {
				return realNumber * 1000;
			}
			return 0;
		} else if (weightStr.indexOf("g") > -1) {
			let obtainSignWeightStr = weightStr.split("g")[0];
			if (obtainSignWeightStr.indexOf("+") > -1) {
				//正数
				let realNumber = Number(obtainSignWeightStr.split("+")[1]);
				if (realNumber > 0) {
					return realNumber;
				}
			} else {
				//正数
				let realNumber = Number(obtainSignWeightStr);
				if (realNumber > 0) {
					return realNumber;
				}
			}
			return 0;
		} else if (weightStr.includes("\n") && !weightStr.includes("kg") && !weightStr.includes("g") && !
			weightStr
				.includes("lb")) {
			// console.log("包含斤",weightStr)
			// 判断斤
			let obtainSignWeightStr = weightStr.split("\n")[0];
			// 20201118单位斤数据格式新增后添加判断
			if (obtainSignWeightStr.includes("jin")) {
				//正数
				let data1 = obtainSignWeightStr.split("  ")[1];
				// console.log("data1-----------",data1);
				let data2 = data1.split(".")[1].substring(0, 3);
				let realNumber = Number(data1.split(".")[0] + "." + data2);
				if (realNumber > 0) {
					return Number((realNumber * 500).toFixed(3));
				}
				return 0;
			} else {
				if (obtainSignWeightStr.indexOf("+") > -1) {
					//正数
					let realNumber = Number(obtainSignWeightStr.split("+")[1]);
					if (realNumber > 0) {
						return Number((realNumber * 500).toFixed(3));
					}
				} else if (obtainSignWeightStr.indexOf("  ") > -1) {
					//正数
					let realNumber = Number(obtainSignWeightStr.split("  ")[1]);
					if (realNumber > 0) {
						return Number((realNumber * 500).toFixed(3));
					}
				}
				return 0;
			}
		} else {
			if (weightStr.indexOf("+") > -1) {
				//正数
				let realNumber = Number(weightStr.split("+")[1]);
				if (realNumber > 0) {
					return Number((realNumber * 500).toFixed(3));
				}
			}
			// console.log("包含斤2",weightStr);
			let data1 = Number(weightStr.split(".")[0]);
			// console.log("data1-----------",data1);
			let data2 = weightStr.split(".")[1].substring(0, 3);
			// console.log("data2-----------",data2);
			let realNumber = Number(data1 + "." + data2);
			// console.log("-----------",realNumber);
			if (realNumber > 0) {
				// console.log("-----------",realNumber);
				return Number((realNumber * 500).toFixed(3));
			}
			return 0;
		}
	} else {
		return 0;
	}
};


// 获取运营时间描述
export const getOperationTimeDesc = (state) => {
	let index = state.currentSortingTimeIndex;
	state.sortingTimeSetting.sortingTimeName = state.operationTimes[index].title;
	state.sortingTimeSetting.sortingStartTime = dateFormat(state.sortingTimeSetting.sortingStartTime, "YYYY-MM-DD");
	if (state.operationTimes[index].end_type == 1) {
		state.sortingTimeSetting.sortingEndTime = dateFormat(state.sortingTimeSetting.sortingStartTime, "YYYY-MM-DD");
		let date = dateFormat(state.sortingTimeSetting.sortingStartTime, "M月D日");
		state.sortingTimeSetting.sortingTimeDesc = date + state.operationTimes[index].start_time + " ~ " + date + state.operationTimes[index].end_time;
		state.sortingTimeSetting.sortingStartTime += " " + state.operationTimes[index].start_time;
		state.sortingTimeSetting.sortingEndTime += " " + state.operationTimes[index].end_time;
	}
	if (state.operationTimes[index].end_type == 2) {
		state.sortingTimeSetting.sortingEndTime = dateFormat(state.sortingTimeSetting.sortingEndTime, "YYYY-MM-DD");
		let date = dateFormat(state.sortingTimeSetting.sortingStartTime, "M月D日");
		let lastDate = dateFormat(computeDateByDay(state.sortingTimeSetting.sortingStartTime, 1), "M月D日");
		state.sortingTimeSetting.sortingTimeDesc = date + state.operationTimes[index].start_time + " ~ " + lastDate + state.operationTimes[index].end_time;
		state.sortingTimeSetting.sortingStartTime += " " + state.operationTimes[index].start_time;
		let lastDateFormat = dateFormat(computeDateByDay(state.sortingTimeSetting.sortingStartTime, 1), "YYYY-MM-DD");
		state.sortingTimeSetting.sortingEndTime = lastDateFormat + " " + state.operationTimes[index].end_time;
	}
};



// WEBPACK FOOTER //
// ./src/libs/util.js